import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumbs from '../../../layout/breadcrumbs';
import AdminSidebar from '../../../layout/admin-sidebar';
import { PaymentMethod } from '../../../../interfaces';
import { useFetchPaymentMethodQuery, useUpdatePaymentMethodMutation } from '../../../../services';
import { handleServerError } from '../../../../helpers';
import Spinner from '../../../shared/spinner';
import PaymentMethodForm from './partials/payment-method-form';

const EditPaymentMethod = () => {
  const navigate = useNavigate();
  const { paymentMethodID } = useParams();
  //@ts-ignore
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>({});
  const [loading, setLoading] = useState<boolean>(false);

  const {
    data,
    isError,
    isLoading,
    isSuccess,
    error,
  } = useFetchPaymentMethodQuery(paymentMethodID as string);

  const [update, { isLoading: isUpdating }] = useUpdatePaymentMethodMutation();

  useEffect(() => {
    if (isError) {
      handleServerError(error);
      navigate(-1);
    }
    if (isSuccess) {
      if (data) {
        setPaymentMethod(data);
      } else {
        toast.error('PaymentMethod not found');
        navigate(-1);
      }
    }
  }, [isError, isSuccess]);

  useEffect(() => {
    setLoading(isLoading || isUpdating);
  }, [isLoading, isUpdating]);

  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    e.preventDefault();
    const { name, value } = e.target;
    setPaymentMethod(prevState => ({
      ...prevState,
      [name]: value,
    }));
  }

  const onSubmit = (e: FormEvent<HTMLFormElement>, instruction: string) => {
    e.preventDefault();
    update({ id: paymentMethodID as string, body: { ...paymentMethod, instruction } })
      .unwrap()
      .then(() => {
        toast.success('Payment Method updated');
        navigate('/admin/payment/methods');
      })
      .catch((reason: any) => {
        handleServerError(reason);
        if (data) {
          setPaymentMethod(data);
        }
      });
  }

  return (
    <div id="page-content">
      <Breadcrumbs crumbs={[
        { page: 'Account', link: '/admin/profile' },
        { page: 'Properties', link: '/admin/properties' },
        { page: 'Edit PaymentMethod' }
      ]}/>

      <div className="container">
        <div className="row">
          <div className="col-md-3 col-sm-2">
            <AdminSidebar/>
          </div>
          <div className="col-md-9 col-sm-10">
            {isLoading && (
              <Spinner text={'Fetching payment method...'}/>
            )}
            {paymentMethod && (
              <PaymentMethodForm paymentMethod={paymentMethod} onSubmit={onSubmit}
                                 onChange={onChange} setPaymentMethod={setPaymentMethod}
                                 isLoading={loading} loadingText={'Updating...'}
                                 submitText={'Edit PaymentMethod'}/>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditPaymentMethod;